import { logger } from '@monofront/logging';
import { IDaySlot } from '@monofront/types';

export const findClosestAvailableSlotToDate = (
  slots: IDaySlot[],
  refDate: Date = new Date(),
): IDaySlot | null => {
  if (!slots || !slots.length) return null;

  return (
    slots
      .filter((slot) =>
        // filter out dayslots without availability
        slot.slots.some((slot) => slot.availableCapacity > 0),
      )
      .sort(
        (slotA, slotB) =>
          // sort dayslots by date asc
          new Date(slotA.date).getTime() - new Date(slotB.date).getTime(),
      )
      .find((slot) => new Date(slot.date).getTime() >= refDate.getTime()) ??
    null
  );
};

export const findNextAvailableSlotDate = (
  nextAvailableDayWithSlots: IDaySlot,
) => {
  if (
    !nextAvailableDayWithSlots?.date ||
    !nextAvailableDayWithSlots?.slots?.length
  ) {
    logger.error('Wrong format of nextAvailableDayWithSlots');

    return null;
  }

  const datePart = new Date(nextAvailableDayWithSlots.date);
  let nextSlotDate: Date | null = null;

  for (const slot of nextAvailableDayWithSlots.slots) {
    if (slot.availableCapacity > 0) {
      const [startHour, startMinute] = slot.value
        .split(' - ')[0]
        .split(':')
        .map(Number);

      const slotDate = new Date(
        datePart.getFullYear(),
        datePart.getMonth(),
        datePart.getDate(),
        startHour,
        startMinute,
      );

      // Update the earliest slot if it is the first valid or earlier than the current nextSlotDate
      if (!nextSlotDate || slotDate < nextSlotDate) {
        nextSlotDate = slotDate;
      }
    }
  }

  return nextSlotDate;
};

export const calculateDateDifferenceInDays = (date1: Date, date2: Date) => {
  const differenceInMs = date1.getTime() - date2.getTime();

  return Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
};
